import React, { Component } from 'react'
import { Box } from '@nike/eds'
import { connect } from 'react-redux'

import config from '../config.js'
import PageTitle from '../components/PageTitle.js'
import NavBar from './NavBar.js'
import TokenSelector from '../auth/TokenSelector.js'
import ParamDebugger from '../auth/ParamDebugger.js'
import HelpBanner from '../components/HelpBanner.js'
import { selectToken } from '../auth/reducer.js'

class App extends Component {
  render() {
    return (
      <PageTitle title={config.appName}>
        <NavBar />
        <Box maxWidth='1600px' ml='auto' mr='auto'>
          <div className='app-body'>
            <HelpBanner />
            <TokenSelector />
            <ParamDebugger />
          </div>
        </Box>
      </PageTitle>
    )
  }
}

export default connect(state => ({
  token: selectToken(state)
}))(App)
